// /user/v1/user/afid/bind
import { createApiMutationHook } from "@/hooks/use-api-mutation";
import { UserAfidBindReq, UserAfidBindRes } from "@/types/api/user/user-afid-bind.d";
import { post } from "@/libs/http";

// 绑定afid
export const afidBind = ({ params }: { params: UserAfidBindReq; }) => {
  return post<UserAfidBindRes>('/user/v1/user/afid/bind', params);
};

export const useAfidBind = createApiMutationHook(afidBind);